































































































































































import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { TaskServicesService } from '@/services/TaskServicesService';
import {
  Configuration,
  ConfigurationChangeModel,
  StoreConstants,
  TaskServiceConstants,
  ValueType,
  TaskServiceRunType,
  RecurrenceModel,
  RecurringTaskServiceSettingsModel,
  TaskServicesGlobalConfigurationModel,
  TaskServiceHostServiceModel,
  TaskServiceHostModel,
  MStoreInputType
} from '@/types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import MStoreFormGroup from '@/components/shared/MStoreFormGroup.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import MStoreRecurrence from '@/components/shared/MStoreRecurrence.vue';
import Vue from 'vue';
import { TaskServiceSettingsConfigurationModel } from '@/types/models/taskService/TaskServiceSettingsConfigurationModel';
import { ValidationModel } from '@/types/models/validation';
import { mapActions, mapGetters } from 'vuex';
import * as CustomSettingsComponents from '@/components/configuration/taskService/customSettings';
import HostsConfiguration from '@/components/configuration/taskService/HostsConfiguration.vue';
import { confirmationHelper } from '@/mixins';
import { Components } from '@/customer';

export default Vue.extend({
  name: 'TaskServiceConfiguration',
  mixins: [confirmationHelper],
  data() {
    return {
      isLoading: true,
      isApplying: false,
      isSaving: false,
      taskServiceConfiguration: {},
      retryAttemptsModeData: '',
      activeTabIndex: 0,
      globalSettings: {} as TaskServicesGlobalConfigurationModel,
      allHosts: [] as TaskServiceHostModel[]
    };
  },
  computed: {
    ...mapGetters(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChange
    ]),
    retryAttemptsMode: {
      get(this: any) {
        return this.retryAttemptsModeData;
      },
      set(this: any, value: string) {
        this.retryAttemptsModeData = value;
        const taskServiceSettings = (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings;
        if (value === 'none') {
          taskServiceSettings.retryAttempts = 0;
          taskServiceSettings.retryWaits = [];
        } else {
          taskServiceSettings.retryAttempts = TaskServiceConstants.DefaultRetryAttempts;
          const retryWaits = [...this.DEFAULT_EXPONENTIAL_RETRY_WAITS];
          taskServiceSettings.retryWaits = retryWaits;
        }
      }
    },
    retryAttempts: {
      get(this: any) {
        return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskServiceSettings?.retryAttempts;
      },
      set(this: any, value: number) {
        const taskServiceSettings = (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings;
        const currentAttempts = { ...taskServiceSettings }.retryAttempts;
        Vue.set(taskServiceSettings, 'retryAttempts', Number(value));
        if (currentAttempts < 0 || value > TaskServiceConstants.MaximumRetyAttempts) {
          return;
        }
        this.updateRetryWaits(value, currentAttempts);
      }
    },
    retryWaits(this: any) {
      return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskServiceSettings?.retryWaits;
    },
    enabled: {
      get(this: any) {
        return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskService?.enabled;
      },
      set(this: any, value: boolean) {
        if ((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskService) {
          Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskService, 'enabled', value);
        }
      }
    },
    jobQueueLimitEnabled: {
      get(this: any) {
        return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskServiceSettings?.hasEnqueuedJobLimit;
      },
      set(this: any, value: boolean) {
        if ((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskServiceSettings) {
          Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings, 'hasEnqueuedJobLimit', value);
        }
      }
    },
    isEditMode(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession];
    },
    isRecurringService(this: any): boolean {
      return this.taskServiceConfiguration?.taskService?.runType === TaskServiceRunType.Recurring;
    },
    recurrence: {
      get(this: any) {
        return (this.taskServiceConfiguration.taskServiceSettings as RecurringTaskServiceSettingsModel).recurrence;
      },
      set(this: any, value: RecurrenceModel) {
        Vue.set(this.taskServiceConfiguration.taskServiceSettings, 'recurrence', value);
      }
    },
    overrideGlobalSettings: {
      get(this: any) {
        return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings.overrideGlobalSettings;
      },
      set(value: boolean) {
        Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings, 'overrideGlobalSettings', value);
        Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings, 'notificationsEnabled', false);
        Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings, 'notificationEmail', '');
      }
    },
    notificationsEnabled: {
      get(this: any) {
        return this.overrideGlobalSettings
          ? this.taskServiceConfiguration.taskServiceSettings.notificationsEnabled
          : (this.globalSettings as TaskServicesGlobalConfigurationModel).notificationsEnabled;
      },
      set(value: boolean) {
        if (!this.overrideGlobalSettings) {
          return;
        }
        Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings, 'notificationsEnabled', value);
      }
    },
    notificationEmail: {
      get(this: any) {
        return this.overrideGlobalSettings ? this.taskServiceConfiguration.taskServiceSettings.notificationEmail : (this.globalSettings as TaskServicesGlobalConfigurationModel).notificationEmail;
      },
      set(value: boolean) {
        if (!this.overrideGlobalSettings) {
          return;
        }
        Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings, 'notificationEmail', value);
      }
    },
    notificationEmailValidation(this: any) {
      return {
        valueType: ValueType.MultipleEmail,
        required: this.overrideGlobalSettings && this.notificationsEnabled
      };
    },
    taskServiceConfigurationHosts: {
      get(this: any) {
        return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.hosts ?? [];
      },
      set(value: TaskServiceHostServiceModel[]) {
        Vue.set(this.taskServiceConfiguration, 'hosts', value);
      }
    },
    enqueuedJobLimit: {
      get(this: any) {
        return (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskServiceSettings?.enqueuedJobLimit;
      },
      set(this: any, value: number) {
        Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings, 'enqueuedJobLimit', value);
      }
    },
    queuedJobLimitValidation(this: any) {
      if (this.taskServiceConfiguration && this.taskServiceConfiguration.taskServiceSettings?.hasEnqueuedJobLimit) {
        const config = this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel;
        return {
          required: true,
          minValue: config.minimumEnqueuedJobLimit,
          maxValue: config.maximumEnqueuedJobLimit,
          valueType: ValueType.Integer
        } as ValidationModel;
      }
      return {
        required: false,
        valueType: ValueType.Integer
      } as ValidationModel;
    },
    numberInputType() {
      return MStoreInputType.Number;
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    ...mapActions(StoreConstants.ConfigurationChange.ModuleName, [StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage]),
    async onCancel(this: any, dirty: boolean) {
      const confirmed = !(await this.hasUnsavedChangesToKeepAsync(this.$bvModal, dirty));
      if (!confirmed) {
        return;
      }
      this.setApplicationDirty(false);
      this.$router.push({ name: Configuration.TaskServices.TaskServices.name });
    },
    async onSave(this: any, reset: () => void, returnToConfigurationPage: boolean) {
      const isValid = await this.$refs.formObserver.validate();
      if (!isValid) {
        const tabIndex = this.getIndexOfFirstTabWithValidationError();
        this.activeTabIndex = tabIndex;
        return;
      }

      const configurationChangeId = (this[StoreConstants.ConfigurationChange.Getters.ConfigurationChange] as ConfigurationChangeModel).id;

      try {
        this.isSaving = returnToConfigurationPage;
        this.isApplying = !returnToConfigurationPage;
        await TaskServicesService.updateTaskServiceConfiguration({
          ...this.taskServiceConfiguration,
          configurationChangeId
        } as TaskServiceSettingsConfigurationModel);
        SnotifyConfiguration.showSuccess('Configuration updated');
        this.setApplicationDirty(false);
        reset();
        if (returnToConfigurationPage) {
          this.$router.push({ name: Configuration.TaskServices.TaskServices.name });
        }
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSaving = false;
        this.isApplying = false;
      }
    },
    getRetryAttemptsMode(this: any) {
      const attempts = (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskServiceSettings?.retryAttempts as number;
      const waits = (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel)?.taskServiceSettings?.retryWaits as number[];
      if (!attempts) {
        this.retryAttemptsModeData = 'none';
        return;
      }

      if (attempts === TaskServiceConstants.DefaultRetryAttempts && waits.length === TaskServiceConstants.DefaultRetryAttempts && waits.every((wait, index) => wait === Math.pow(2, index))) {
        this.retryAttemptsModeData = 'default';
        return;
      }

      this.retryAttemptsModeData = 'specify';
    },
    async getTaskServiceConfiguration(this: any) {
      this.taskServiceConfiguration = await TaskServicesService.getTaskServiceConfiguration(this.$route.params.serviceName);
      if (this.isRecurringService && !this.taskServiceConfiguration.taskServiceSettings.recurrence) {
        this.taskServiceConfiguration.taskServiceSettings.recurrence = this.taskServiceConfiguration.defaultRecurrence;
      }
    },
    updateWait(value: string, index: number) {
      const updatedValue = value !== '' && Number(value) >= 0 ? Number(value) : value;
      Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings.retryWaits, index, updatedValue);
    },
    updateRetryWaits(updatedAttempts: number) {
      const taskServiceSettings = (this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings;
      const currentRetryWaitsLength = [...taskServiceSettings.retryWaits].length;
      if (updatedAttempts < currentRetryWaitsLength) {
        Vue.set(taskServiceSettings, 'retryWaits', taskServiceSettings.retryWaits.slice(0, updatedAttempts));
        taskServiceSettings.retryWaits = taskServiceSettings.retryWaits.slice(0, updatedAttempts);
      } else {
        let waitsToAdd = new Array(updatedAttempts - currentRetryWaitsLength).fill('');
        const usingDefaults = taskServiceSettings.retryWaits.every((wait, index) => wait === Math.pow(2, index));
        if (usingDefaults) {
          waitsToAdd = waitsToAdd.map((_, index) => Math.pow(2, currentRetryWaitsLength + index));
        }
        Vue.set(taskServiceSettings, 'retryWaits', [...taskServiceSettings.retryWaits, ...waitsToAdd]);
      }
    },
    getDefaultExponentialRetryWaits(): number[] {
      return new Array<number>(TaskServiceConstants.DefaultRetryAttempts).fill(0).map((_, index) => Math.pow(2, index));
    },
    updateCustomSetting(this: any, key: string, value: any) {
      Vue.set((this.taskServiceConfiguration as TaskServiceSettingsConfigurationModel).taskServiceSettings, key, value);
    },
    getIndexOfFirstTabWithValidationError(this: any): number {
      return (Object.values(this.$refs.formObserver.ctx.errors) as string[][]).findIndex((x) => x.length > 0);
    },
    async getGlobalSettings() {
      this.globalSettings = await TaskServicesService.getGlobalConfiguration();
    },
    async getAllHosts() {
      this.allHosts = await TaskServicesService.getAllHosts();
    }
  },
  async mounted(this: any) {
    await Promise.all([
      this.getTaskServiceConfiguration(),
      this[StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage](this.CHANGE_CONTROLLER_PATH),
      this.getGlobalSettings(),
      this.getAllHosts()
    ]);
    this.getRetryAttemptsMode();
    this.isLoading = false;
  },
  created(this: any) {
    this.WAIT_VALIDATION = { minValue: 0, required: true, valueType: ValueType.Integer } as ValidationModel;
    this.CHANGE_CONTROLLER_PATH = 'taskServicesConfiguration';
    this.DEFAULT_EXPONENTIAL_RETRY_WAITS = this.getDefaultExponentialRetryWaits();
    this.RETRY_ATTEMPTS_VALIDATION = {
      minValue: 0,
      maxValue: TaskServiceConstants.MaximumRetyAttempts
    } as ValidationModel;
  },
  components: {
    LoadingSpinner,
    MStoreFormInput,
    MStoreForm,
    MStoreFormGroup,
    MStoreFormCheckbox,
    MStoreSpinnerButton,
    ...CustomSettingsComponents,
    MStoreRecurrence,
    HostsConfiguration,
    ...Components.TaskServices
  }
});
